import { useState } from 'react'
import { Link } from 'react-router-dom'
import { api } from '@/api/client'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Logo } from '@/components/shared/Logo'

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('')
  const [loading, setLoading] = useState(false)
  const [submitted, setSubmitted] = useState(false)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setLoading(true)
    try {
      await api.post('/auth/forgot-password', { email })
    } catch {
      // Swallow errors — always show success to prevent enumeration
    } finally {
      setLoading(false)
      setSubmitted(true)
    }
  }

  return (
    <div className="min-h-screen flex bg-slate-50">
      <div className="hidden lg:flex flex-col justify-between w-2/5 bg-gradient-to-br from-indigo-600 to-indigo-800 p-12">
        <Logo size={64} theme="dark" />
        <div>
          <p className="text-indigo-200 text-sm font-medium uppercase tracking-widest mb-3">Training compliance</p>
          <p className="text-white text-3xl font-semibold leading-snug">
            Training management software for training companies.
          </p>
        </div>
        <div>
          <p className="text-indigo-300 text-sm">© {new Date().getFullYear()} CertSlate</p>
          <p className="text-indigo-400 text-xs mt-1 leading-relaxed">CertSlate is a trading name of DJRS Care Services Ltd. (company number: 17074229)</p>
        </div>
      </div>

      <div className="flex flex-1 items-center justify-center px-8">
        <div className="w-full max-w-sm">
          <div className="mb-6 lg:hidden"><Logo size={44} theme="light" /></div>

          {submitted ? (
            <>
              <h2 className="text-xl font-semibold text-slate-900 mb-2">Check your inbox</h2>
              <p className="text-slate-500 text-sm mb-8">
                If an account exists for that email, you'll receive a reset link shortly.
              </p>
              <Link to="/login" className="text-sm text-indigo-600 hover:text-indigo-700 font-medium">
                Back to sign in
              </Link>
            </>
          ) : (
            <>
              <h2 className="text-xl font-semibold text-slate-900 mb-2">Forgot your password?</h2>
              <p className="text-slate-500 text-sm mb-8">Enter your email and we'll send you a reset link.</p>

              <form onSubmit={handleSubmit} className="space-y-5">
                <div className="space-y-1.5">
                  <Label htmlFor="email">Email</Label>
                  <Input
                    id="email"
                    type="email"
                    autoComplete="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>
                <Button type="submit" className="w-full" disabled={loading}>
                  {loading ? 'Sending…' : 'Send reset link'}
                </Button>
              </form>

              <p className="mt-6 text-sm text-slate-500">
                <Link to="/login" className="text-indigo-600 hover:text-indigo-700 font-medium">
                  Back to sign in
                </Link>
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  )
}
